import React from 'react'

//Default suggestion item
export const Item = ({ text }) => {
  return <span>{text}</span>
}
